import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteFeriadoModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/feriados',
    nameForTitle: 'Feriado',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteFeriadoModal
